<template>
    <div class="user-action">
        <div class="user-action__item">
            <div class="user-action__item-icon" @click="handleLike" @mouseenter="likeHover = true" @mouseleave="likeHover=false" tabindex="0">
                <img src="@/assets/images/action-like.svg" v-if="!likeHover && likeStatus === '0'" alt="">
                <img src="@/assets/images/action-like-hover.svg" v-if="likeHover && likeStatus === '0'" alt=""> 
                <img src="@/assets/images/action-like-active.svg" v-if="likeStatus === '1'" alt="">
            </div>
             <span class="num" :style="likeStatus === '1' ? 'background-color: #69B1AE;':''">{{ likeCount }}</span>
        </div>
        <div class="user-action__item" @mouseenter="commentHover = true" @mouseleave="commentHover=false" tabindex="0">
            <div class="user-action__item-icon" @click="scrollIntoComment">
                <img src="@/assets/images/action-comment.svg" v-if="!commentHover" alt="" >
                <img src="@/assets/images/action-comment-hover.svg" v-if="commentHover" alt="">
            </div>
            <span class="num">{{ commentCount }}</span>
        </div>
        <div class="user-action__item" >
            <div class="user-action__item-icon" @click="handleCollect" @mouseenter="collectHover = true" @mouseleave="collectHover=false" tabindex="0">
                <img src="@/assets/images/action-collect.svg" v-if="!collectHover && collectStatus === '0'" alt="">
                <img src="@/assets/images/action-collect-hover.svg" v-if="collectHover && collectStatus === '0'" alt="">
                <img src="@/assets/images/action-collect-active.svg" v-if="collectStatus === '1'" alt="">
            </div>
            <span class="num" :style="collectStatus === '1' ? 'background-color: #69B1AE;':''">{{ collectCount }}</span>
        </div>
        <div class="user-action__item">
            <div class="user-action__item-icon" @click="handleReport" @mouseenter="reportHover = true" @mouseleave="reportHover=false" tabindex="0">
                <img src="@/assets/images/action-report.svg" v-if="!reportHover && reportStatus === '0'" alt="">
                <img src="@/assets/images/action-report-hover.svg" v-if="reportHover && reportStatus === '0'" alt="">
                <img src="@/assets/images/action-report-active.svg" v-if="reportStatus === '1'" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            likeHover: false,
            commentHover: false,
            collectHover: false,
            reportHover: false,
        }
    },
    props: {
        likeStatus: {
            type: String,
            default: '0'
        },
        likeCount: {
            type: Number,
            default: 0
        },
        commentCount: {
            type: Number,
            default: 0  
        },
        collectStatus: {
            type: String,
            default: '0'
        },
        collectCount: { 
            type: Number,
            default: 0
        },
        reportStatus: {
            type: String,
            default: '0'    
        }
    },
    methods: {
        handleLike() {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }
            if (this.likeStatus === '0') {
                this.$emit('handleLike', '1');
            } else {
                this.$emit('handleLike', '0');
            }
        },
        handleCollect() {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }
            if (this.collectStatus === '0') {
                this.$emit('handleCollect', '1');
            } else {
                this.$emit('handleCollect', '0');
            }
        },
        handleReport() {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }
            if (this.reportStatus === '0') {
                this.$emit('handleReport');
            } else {
                this.$message.warning('请勿重复举报');
            }
        },
        scrollIntoComment() {
            let offsetTop = document.querySelector('.detail-block .comment-area').offsetTop
            window.scrollTo({
                top: offsetTop + (this.isTopbarBlock ? -80 : 0)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.user-action {
  display: flex;
  flex-direction: column;
    margin-top: 45px;
 .user-action__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 12px;
    position: relative;
    .num {
        display: block;
        position: absolute;
        left: 35px;
        border-radius: 8px;
        padding: 0px 4px;
        background-color: #bbb;
        color: #fff;
        font-size: 12px;
    }
}

.user-action__item-icon {
    background-color: #FFF;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: 20px;
    cursor: pointer;
    
    &:hover {
      background-color: #ebedef;
    }

}

}
</style>
